import { PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './flat-button.module.scss';

interface Props extends PropsWithChildren {
    style?: React.CSSProperties;
    disabled?: boolean;
    onClick?: () => void;
}

const FlatButton = ({ children, style, disabled, onClick }: Props) => {
    return (
        <button
            className={classnames({
                [styles.flatButton]: true,
                [styles.disabled]: disabled,
            })}
            style={style}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default FlatButton;
